function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSourceWastetemp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    rx: 2,
    style: {
      fill: "#ACABAB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.158 10.966a5.333 5.333 0 1 0 6.4 0V3.499h-6.4v7.467Zm4.267 0V5.632H8.292v5.334h2.133Z",
    clipRule: "evenodd",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.692 7.766h5.333v2.133h-5.333V7.766ZM20.025 3.499h-3.2v2.133h3.2V3.499ZM16.825 12.032h3.2v2.134h-3.2v-2.134ZM20.025 16.299h-3.2v2.133h3.2v-2.133Z",
    style: {
      fill: "#000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSourceWastetemp);
export default __webpack_public_path__ + "static/media/icon-source-wastetemp.0dff5c75445dbd52b711f8b481b70f5d.svg";
export { ForwardRef as ReactComponent };